import {Component, OnInit} from '@angular/core';
import {IShard} from "../company-create/models/shard";
import {CompanyHttpService} from "./services/company-http.service";
import {GlobalAlertService} from "../../../_services/global-alert.service";
import {AlertLevel} from "../../../enums/alert-level";
import {ICompany} from "../company-create/models/company";
import {PageScrollableComponent} from "../../../_components/page-scrollable/page-scrollable.component";
import {PageContainerComponent} from "../../../_components/page-container/page-container.component";
import {HeaderContainerComponent} from "../../../_components/header-container/header-container.component";

@Component({
  selector: 'app-company-overview',
  templateUrl: './company-overview.component.html',
  imports: [
    PageScrollableComponent,
    PageContainerComponent,
    HeaderContainerComponent
  ],
  styleUrl: './company-overview.component.scss'
})
export class CompanyOverviewComponent implements OnInit {
  protected shards: { [key: string]: IShard[] } = {};
  protected companies: ICompany[] = [];
  protected search: string = "";
  private _shards: { [key: string]: IShard[] } = {};
  private _companies: ICompany[] = [];

  constructor(private http: CompanyHttpService, private gas: GlobalAlertService) {
  }

  ngOnInit(): void {
    this.load();
  }

  assign(companies: ICompany[]) {
    this._companies = companies;
    this._shards = {};
    this._companies.filter(c => c.id).forEach(company => {
      this._shards[company.id!] = company.shards;
    })
  }

  filter(search: string | undefined = undefined) {
    if (search) {
      this.search = search;
    }
  }

  private includeCompany(company: ICompany) {
    this.companies.push(company);
    this.shards[company.id!] = Object.assign([], company.shards);
  }

  private includeShard(company: ICompany, shard: IShard) {
    this.companies.push(company);
    this.shards[company.id!] = [shard]
  }

  private load(): void {
    this.http.list().withLoadingIndicator().subscribe({
      next: companies => {
        this._companies = companies;
      },
      error: err => {
        this.gas.createAndShow("Fehler", "Fehler beim Laden der Unternehmen.", AlertLevel.error);
        console.error(err);
      }
    })
  }
}
